import { render, staticRenderFns } from "./getOnlineUsers.vue?vue&type=template&id=663120d9&scoped=true&"
import script from "./getOnlineUsers.vue?vue&type=script&lang=js&"
export * from "./getOnlineUsers.vue?vue&type=script&lang=js&"
import style0 from "./getOnlineUsers.vue?vue&type=style&index=0&id=663120d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663120d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VIcon,VList,VListItem,VMenu})
